import { ActionBar, ChakraBox, ChakraFlex, FAIconName } from '@equip.health/ui';

export const DischargePlanErrorFallback = () => {
  return (
    <ChakraFlex
      display="unset"
      id="discharge-plan-error-fallback"
      margin="18px"
      padding="18px"
      width="100%"
    >
      <ChakraBox alignItems="center" width="100%">
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          id="discharge-plan-error-action-bar"
          text="We encountered an unexpected error loading the discharge plan."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
